// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"email-modal-warning_backdrop__20AYi","modal":"email-modal-warning_modal__3Ok2J"};